import axios from 'axios'

export default {
    GETPLANS ({ commit }) {
        return axios.get('/plans').then((response) => {
            const { data: { data } } = response
            commit('planList', {plans: data})
        }, (err) => {
            console.log('err ', err)
        })
    },
    GETPLAN ({ commit }, reqPlan) {
        return axios.get(`/plans/getDefaultPlan/${reqPlan}`).then((response) => {
            const { data: { data } } = response
            commit('SetDefaultPlan', {defaultPlan: data})
        }, (err) => {
            console.log('err ', err)
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/plans/actions.js